import { render, staticRenderFns } from "./termsPrivacy.vue?vue&type=template&id=6124e27c&scoped=true&"
import script from "./termsPrivacy.vue?vue&type=script&lang=js&"
export * from "./termsPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./termsPrivacy.vue?vue&type=style&index=0&id=6124e27c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6124e27c",
  null
  
)

export default component.exports